import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Radio } from "lucide-react";
import { api } from "../lib/api";

export default function LiveBadge() {
  const [live, setLive] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const r = await api.get("/live-streams/current");
        setLive(r.data?.id ? r.data : null);
      } catch { setLive(null); }
    };
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);

  if (!live) return null;

  return (
    <Link
      to="/live"
      data-testid="live-badge"
      className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-[#CE1126]/15 hover:bg-[#CE1126]/25 border border-[#CE1126]/40 text-[#CE1126] text-[11px] font-semibold uppercase tracking-wider transition-colors"
      title={live.title}
    >
      <span className="relative flex h-1.5 w-1.5">
        <span className="absolute inline-flex h-full w-full rounded-full bg-[#CE1126] opacity-75 animate-ping" />
        <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-[#CE1126]" />
      </span>
      <Radio size={11} /> En direct
    </Link>
  );
}
